import { BOOKING_AGENT_STORAGE_KEY } from './config';

const PAYMENT_DRAFT_STORAGE_KEY = 'knowmediq.paymentDraft.v1';

export function loadBookingAgentState() {
  try {
    const raw = window.localStorage.getItem(BOOKING_AGENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveBookingAgentState(state) {
  try {
    window.localStorage.setItem(BOOKING_AGENT_STORAGE_KEY, JSON.stringify(state));
    return true;
  } catch {
    return false;
  }
}

export function clearBookingAgentState() {
  try {
    window.localStorage.removeItem(BOOKING_AGENT_STORAGE_KEY);
  } catch {
    return;
  }
}

export function loadPaymentDraft() {
  try {
    const raw = window.localStorage.getItem(PAYMENT_DRAFT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function savePaymentDraft(state) {
  try {
    window.localStorage.setItem(PAYMENT_DRAFT_STORAGE_KEY, JSON.stringify(state));
    return true;
  } catch {
    return false;
  }
}

export function clearPaymentDraft() {
  try {
    window.localStorage.removeItem(PAYMENT_DRAFT_STORAGE_KEY);
  } catch {
    return;
  }
}
